module.exports = __webpack_public_path__ + "static/media/icon_earn_empty.364fed9c.webp";